// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1fjkj","modalFooterButton":"ModalNotes_modalFooterButton__1xPy0"};